import "./Schools.css";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { MoonLoader } from "react-spinners";
import { BaseURL } from "../../Hooks/URL";
import ApartmentIcon from "@mui/icons-material/Apartment";
import TextFieldInput from "../../Components/Atoms/Inputs/TextField/TextFieldInput";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { Pagination } from "@mui/material";
import Filter from "../../Components/Molecules/Filter/Filter";
import SchoolIcon from "@mui/icons-material/School";
import AddIcon from "@mui/icons-material/Add";
import SortButton from "../../Components/Molecules/SortButton/SortButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#012369",
    color: theme.palette.common.white,
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "none",
    padding: "16px 12px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "14px",
    padding: "16px 12px",
    borderBottom: "1px solid #f0f1f3",
    color: "#333",
  },
}));

const columns = [
  {
    id: "logoFilePath",
    label: "",
    minWidth: 50,
  },
  { id: "name", label: "Name", minWidth: 150 },
  {
    id: "email",
    label: "Email Address",
    minWidth: 150,
  },
  { id: "phone", label: "Phone Number", minWidth: 150 },
  { id: "country", label: "Country", minWidth: 100 },
  { id: "city", label: "City", minWidth: 100 },
  { id: "active", label: "Activated", maxWidth: 100, align: "center" },
];

function Schools({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  schools,
  setSchools,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  totalCount,
  setSort,
  currentSort,
}) {
  // if (loading) {
  //   return (
  //     <div className="mainContainer">
  // <div className="loadingContainer">
  //   <MoonLoader color="#012369" size={40} />
  // </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mainContainer">
      {/* Page Header */}
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleIcon">
            <SchoolIcon />
          </div>
          <div className="titleContent">
            <h1>Schools Management</h1>
            <p>Manage and view all registered schools</p>
          </div>
        </div>

        <button
          className="actionButton primary addButton"
          onClick={() => navigate("/schools/add")}
        >
          <AddIcon />
          Add School
        </button>
      </div>

      {/* Statistics Cards */}
      {loading ? (
        ""
      ) : (
        <>
          <div className="statsGrid">
            <div className="statsGrid" style={{ marginBottom: "0px" }}>
              <div className="statCard">
                <div className="statIcon primary">
                  <SchoolIcon />
                </div>
                <div className="statContent">
                  <h4>Total Schools</h4>
                  <h2>{totalCount || 0}</h2>
                </div>
              </div>
              <div className="statCard">
                <div className="statIcon success">
                  <DoneIcon />
                </div>
                <div className="statContent">
                  <h4>Active Schools</h4>
                  <h2>
                    {schools?.filter((school) => school.active).length || 0}
                  </h2>
                </div>
              </div>
              <div className="statCard">
                <div className="statIcon warning">
                  <CloseIcon />
                </div>
                <div className="statContent">
                  <h4>Pending Schools</h4>
                  <h2>
                    {schools?.filter((school) => !school.active).length || 0}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Schools Table */}
      <div className="contentSection">
        <div className="tableHeader">
          <h2 className="sectionTitle">Schools List</h2>
        </div>

        <div className="searchFilterHeader">
          <div className="searchFilterGroup">
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search schools..."}
              className="modernSearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search !== searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13) {
                  if (search !== searchData) {
                    setSearch(searchData);
                  }
                }
              }}
            />
            <Filter country city activated setFilter={setFilter} />
            <SortButton
              setSort={setSort}
              currentSort={currentSort}
              name
              joinDate
              createdAt
            />
          </div>
        </div>

        {loading ? (
          ""
        ) : (
          <>
            <div className="tableHeaderCount">
              <div className="tableActions">
                <span className="resultsCount">
                  Showing {schools?.length || 0} schools
                </span>
              </div>
            </div>
          </>
        )}

        {loading ? (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        ) : (
          <>
            {schools && schools.length > 0 ? (
              <div className="modernTableContainer">
                <Table stickyHeader aria-label="schools table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {schools.map((school) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={school.code}
                        onClick={() => navigate(`/schools/${school.id}`)}
                        className="modernTableRow"
                      >
                        {columns.map((column) => {
                          const value = school[column.id];
                          return (
                            <StyledTableCell
                              key={column.id}
                              align={column.align}
                            >
                              {column?.id === "logoFilePath" ? (
                                value ? (
                                  <img
                                    alt="school logo"
                                    src={`${BaseURL}/${value}`}
                                    className="schoolTableLogo"
                                  />
                                ) : (
                                  <div className="schoolTableLogoPlaceholder">
                                    <ApartmentIcon />
                                  </div>
                                )
                              ) : column?.id === "active" ? (
                                <div
                                  className={`statusIndicator ${
                                    value ? "active" : "inactive"
                                  }`}
                                >
                                  {value ? <DoneIcon /> : <CloseIcon />}
                                  {value ? "Active" : "Inactive"}
                                </div>
                              ) : column?.id === "country" ||
                                column?.id === "city" ? (
                                value?.name || "-"
                              ) : (
                                value || "-"
                              )}
                            </StyledTableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <div className="emptyState">
                <div className="emptyIcon">
                  <SchoolIcon />
                </div>
                <h3>No Schools Found</h3>
                <p>
                  No schools have been added yet. Start by adding your first
                  school.
                </p>
                <button
                  className="actionButton primary"
                  onClick={() => navigate("/schools/add")}
                  style={{ margin: "20px auto" }}
                >
                  <AddIcon />
                  Add First School
                </button>
              </div>
            )}
          </>
        )}

        {loading ? (
          ""
        ) : (
          <>
            {/* Pagination */}
            {schools && schools.length > 0 && (
              <div className="paginationContainer">
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  size="large"
                  color="primary"
                  className="paginationCount"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Schools;
